// Placement results — renders the long-scroll keepsake (HOP-27).
//
// Used in two places:
//   1. Inline by EvaluationWizard right after the quick check ("done" step)
//   2. EvaluationResultsV2Surface when revisiting saved results
//
// The report's CTAs are the navigation: "See books" lands on the Books
// shelf; "Upload a book" opens the upload flow. Both call onDone first so
// the wizard (when inline) tears down cleanly.

import { useGlobalState } from '@/stores/globalState';
import { PlacementReport } from '@/components/hs/PlacementReport';
import type { EvaluationResultsV2 } from '@/types';
import { PH_UNMASK } from '@/lib/privacyMask';import { CssVarDiv } from "@/components/CssVarElements";

interface EvaluationResultsV2ViewProps {
  result: EvaluationResultsV2;
  learnerName: string;
  onDone: () => void;
}

export function EvaluationResultsV2View({
  result,
  learnerName,
  onDone
}: EvaluationResultsV2ViewProps) {
  const setActiveModule = useGlobalState((s) => s.setActiveModule);
  const setActiveWorkspaceItem = useGlobalState((s) => s.setActiveWorkspaceItem);
  const setWorkspaceView = useGlobalState((s) => s.setWorkspaceView);

  const handleSeeBooks = () => {
    onDone();
    setActiveModule('BOOKS');
  };

  const handleUploadBook = () => {
    onDone();
    setActiveModule('MY_GUIDES');
    setActiveWorkspaceItem('new');
    setWorkspaceView('FOCUSED');
  };

  const handleRetake = () => {
    onDone();
    setActiveModule('EVALUATION');
    setActiveWorkspaceItem('evaluation-flow');
    setWorkspaceView('FOCUSED');
  };

  const placedAt = result.completedAt ? new Date(result.completedAt) : undefined;

  return (
    <CssVarDiv cssVars={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }} {...PH_UNMASK}>
      <PlacementReport
        learnerName={learnerName}
        stageValue={result.finalStage ?? 0}
        memorizerFlag={result.memorizerFlag ?? false}
        placedAt={placedAt}
        onSeeBooks={handleSeeBooks}
        onUploadBook={handleUploadBook}
        onRetake={handleRetake} />

    </CssVarDiv>);

}